module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.4e045625.png";